<template>

  <div id="loginbg">  ·
    <div id="ding">
      <div class="title"id="wenzi">
        自提系统
      </div>
      <div class="title"id="zhanghao">
        账号
      </div>
      <div class="title"id="tuichu"@click="logout">
        【退出】
      </div>
      <div class="title"id="yuyue"@click="chakan">
        查看商品
      </div>
    </div>
    <!--<div id="lujing">
    </div>-->

    <el-form :model="resform"  id="products1" :rules="rules3" label-width="100px" ref="resform">
      <div id="lujingkongzhi">
        <img id="lujing" src="../../assets/信息填写.png">
      </div>
      <el-form-item label="提货卡卡号:" style="margin-left: 20px" >
        <el-row onfocus="this.blur()" >{{this.$route.query.card}}</el-row>
      </el-form-item>
      <el-form-item label="收件人姓名:" prop="name" style="margin-left: 20px" >
        <el-input v-model="resform.name"clearable></el-input>
      </el-form-item>
      <el-form-item label="收件人电话:" prop="phone" style="margin-left: 20px">
        <el-input v-model="resform.phone"clearable></el-input>
      </el-form-item>
      <el-form-item label="验证码:" prop="code" style="margin-left: 20px">
        <el-input v-model="resform.code"clearable></el-input>
        <el-button id="code" type="primary" size="mini" style="position: absolute;left: 323px;top: 6px;width: 100px" @click="sendCode" :disabled="codeDisabled">{{codeMsg}}</el-button>
      </el-form-item>
      <el-form-item label="地址:" prop="address" style="margin-left: 20px">
          <v-distpicker v-model="resform.address"
                        @province="provinceChange"
                        :province="resform.province"
                        @city="cityChange"
                        :city="resform.city"
                        @area="areaChange"
                        :area="resform.area"
                        >
            </v-distpicker>
      </el-form-item>
      <!--<template>
        <v-distpicker @province="provinceChange"
                      province=""
                      @city="cityChange"
                      city=""
                      @area="areaChange"
                      area=""
        ></v-distpicker>
      </template>-->
      <el-form-item label="详细地址:" prop="detailAddress" style="margin-left: 20px" >
        <el-input v-model="resform.detailAddress"clearable></el-input>
      </el-form-item>
      <el-form-item label="发货时间:" prop="appointmentTime" style="margin-left: 20px">
        <div class="block">
          <span class="demonstration"></span>
          <el-date-picker
              v-model="resform.appointmentTime"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button type="primary"  style="width:100%;margin-left: -30px;" @click="reservationSave" :loading="resLoading">预约</el-button>
      </el-form-item>
      <div style="background-color: #eaeaea;width: 570px;height: 70px;border-radius:7px;height: 65px;">
        <div style="top: 645px;width: 500px;margin-left: 40px;">
          提示：快递公司收件后正常情况下可以当天发出。一般快递公司正常每天装包发车的时间为下午四点，在装包发车时间之前被快递员收取的快递，当天都可以正常发出。请用户合理安排时间。
        </div>
      </div>

    </el-form>

  </div>
</template>
<script>
  import VDistpicker from 'v-distpicker';//引入v-distpicker
  //import NProgress from 'nprogress'
  export default {
    components:{
      VDistpicker//注册组件
    },
    data() {
      return {
        // 是否禁用按钮
        codeDisabled: false,
        // 倒计时秒数
        countdown: 60,
        // 按钮上的文字
        codeMsg: '获取验证码',
        // 定时器
        timer: null,
        province:"",
        city :"",
        area :"",
        resform:{
          card:"",
          phone:"",
          name:"",
          address:"",
          detailAddress:"",
          appointmentTime:null,
          code:"",
          province:"",
          city :"",
          area :"",
        },
        resLoading:false,
        logining: false,
        rules3: {
          name: [
            { required: true, message: '请输入收件人姓名', trigger: 'blur' },
            //{ validator: validaePass }
          ],
          phone: [
            { required: true, message: '请输入收件人电话', trigger: 'blur' },
            { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的号码格式', trigger: 'change' }
            //{ validator: validaePass2 }
          ],
          code: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          address: [
            { required: true, message: '请输入地址', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          detailAddress: [
            { required: true, message: '请输入详细地址', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          appointmentTime: [
            { required: true, message: '请选择发货时间', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
          url: '../../assets/LOGO-800.png'
        },
        checked: false
      };
    },
    methods: {
      //三个选择框的值改变事件，data参数：返回选择框改变时候的值，是一个对象
      provinceChange(event) {//省
        this.province = event.value;
        //this.resform3.address = this.province;
      },
      cityChange(event) {//市
        this.city = event.value;
        /*if (this.resform3.address == this.city) {
          this.resform3.address = this.city;
        } else {
          this.resform3.address += this.city;
        }*/
      },
      areaChange(event) {//区、县
        this.area = event.value;
        this.resform.address = this.area;
      },
      reservationSave(){
        this.$refs.resform.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.resLoading = true;
              if (this.province == this.city || this.city == '县') {
                this.resform.address = this.province + this.area
              }else if (this.city == this.area){
                this.resform.address = this.province + this.city
              }else {
                this.resform.address = this.province + this.city + this.area
              }
              this.resform.province = this.province;
              this.resform.city = this.city;
              this.resform.area = this.area;
              this.resform.card = this.$route.query.card;
              let para = Object.assign({}, this.resform);
              this.$http.post("/reservationOrder/save",para).then(res=>{
                this.resLoading = false;
                if(res.data.success){
                  this.$message({
                    message: '预约成功',
                    type: 'success'
                  });
                  var phone1 = this.resform.phone
                  this.$router.push({ path: '/userReservationOrder' ,query: {phone:phone1} });
                }else{
                  this.$message.error(res.data.message);
                }
              })
            }).catch(error => {
              this.$message({
                message: '预约失败',
                type: 'error'
              });
              this.resLoading = false;
              return;
            });
          }
        });
      },

      sendCode(){
        //1.判断手机号不为空
        if(!this.resform.phone){
          this.$message({
            message: "手机号不能为空",
            type: 'error'
          });
          return;
        }
        var loginPhone = {
          phone: this.resform.phone
        };
        this.$http.post("/code/send",loginPhone).then(result =>{
          if (result.data.success) {
            this.$message.success("手机验证码已经发送到您的手机，请在3分钟内使用");
            // 验证码60秒倒计时
            if (!this.timer) {
              this.getValidStr();
              this.timer = setInterval(this.getValidStr, 1000)
            }
          }else {
            this.$message.error(result.data.message);
          }
        }).catch(result =>{
          this.$message({
            message: "获取失败",
            type: 'error'
          });
        })
      },
      getValidStr(){
        if (this.countdown > 0 && this.countdown <= 60) {
          this.countdown--;
          if (this.countdown !== 0) {
            this.codeMsg = "重新发送" + this.countdown + "S";
            this.codeDisabled = true;
          } else {
            clearInterval(this.timer);
            this.codeMsg = "获取验证码";
            this.countdown = 60;
            this.timer = null;
            this.codeDisabled = false;
          }
        }
      },
      chakan(){
        this.card = this.$route.query.card;
        var card2 = this.card;
        this.$router.push({ path: '/cardProduct',query: {card:card2} });
      },
      //退出
      logout: function () {
        this.$confirm('确认退出吗?', '提示', {
          //type: 'warning'
        }).then(() => {
          //====================退出的时候需要刷新一下本地的路由缓存
          //location.reload();
          //================
          this.$router.push({ path: '/login' });
        }).catch(() => {
        });
      },
    },
    mounted() {
    }
  }

</script>

<style lang="scss" scoped>
  #products1{
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 30px auto;
    width: 550px;
    padding: 14px 50px 35px 45px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }
  #loginbg{
    background-image: url('../../assets/login.png');
    background-position: center;
    background-size:  100% 100%;background-repeat: no-repeat;
    height: 100%;
    //background-color: black;
  }
  #ding{
    background-color: #303133;
    height: 58px;
    margin-top: -18px;
  }
  #wenzi{
    position: absolute;
    margin-top: 18px;
    font-size: large;
    color: white;
    left: 100px;
    font-family: "PingFang SC";
    font-weight: 600;
  }
  #zhanghao{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 230px;
    font-family: "PingFang SC";
    font-weight: 400;
  }
  #tuichu{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 400px;
    font-family: "PingFang SC";
    font-weight: 400;
    cursor:pointer
  }
  #tuichu:hover {
    color: #c1e9f8;
  }
  #yuyue{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 305px;
    font-family: "PingFang SC";
    font-weight: 400;
    cursor:pointer
  }
  #yuyue:hover {
    color: #c1e9f8;
  }
  #lujing{
    //position: absolute;
    height: 50px;
    margin-left: 130px;
    margin-top: -50px;
  }
  #lujingkongzhi{
    //position: absolute;
    //height: 40px;
    //top: 138px;
  }
  #dazhaxie{
    width: 200px;
    margin-left: 70px;
  }
</style>



// WEBPACK FOOTER //
// ReservationOrder.vue?4b3a0808